<div class="columns-block" [class]="customCss()" [class.show-borders]="showBorders()">
  @if (isEditable()) {
    <div class="columns-controls" contenteditable="false">
      <span
        class="columns-control-btn"
        [class.active]="showBorders()"
        (click)="toggleBorders()"
        dojoStopPropagation
        [matTooltip]="showBorders() ? 'Hide column dividers' : 'Show column dividers'"
        >┃</span
      >
      @if (canRemoveColumn()) {
        <span class="columns-control-btn" (click)="removeLastColumn()" dojoStopPropagation title="Remove column"
          >−</span
        >
      }
      <span class="columns-control-label">{{ columnCount() }} cols</span>
      @if (canAddColumn()) {
        <span class="columns-control-btn" (click)="addColumn()" dojoStopPropagation title="Add column">+</span>
      }
    </div>
  }

  <div tiptapNodeViewContent></div>
</div>
